import { FiMoon, FiSun } from "react-icons/fi";
import useTheme from "../hooks/theme";

const Toggle = () => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <label className="relative inline-flex cursor-pointer items-center gap-2">
      <FiSun className={`text-base transition ${isDark ? 'text-slate-500' : 'text-brand-orange'}`} />
      <div className="relative">
        <input
          type="checkbox"
          className="sr-only peer"
          checked={isDark}
          onChange={toggleTheme}
        />
        <div className="h-7 w-12 rounded-full bg-slate-200 transition-all shadow-lg  duration-300 peer-checked:bg-brand-orange peer-focus:ring-4 peer-focus:ring-brand-orange/30 dark:bg-slate-700" />
        <div className="absolute left-1 top-1 h-5 w-5 rounded-full border border-slate-300 bg-white shadow transition-transform duration-300 peer-checked:translate-x-5 dark:border-slate-600" />
      </div>
      <FiMoon className={`text-base transition ${isDark ? 'text-brand-orange' : 'text-slate-400'}`} />
    </label>
  );
};

export default Toggle;
